/**
 * Copies `--tpl-*` CSS variables and base typography from the nearest editor
 * theme root so portaled / fixed UI matches the editor surface (see MergeTagSuggestion).
 */
export function syncEditorThemeToPortal(
  trigger: HTMLElement | null | undefined,
  panel: HTMLElement | null | undefined,
): void {
  if (!trigger || !panel) return;
  const themeRoot = trigger.closest<HTMLElement>("[data-tpl-theme]");
  if (!themeRoot) return;
  const themeValue = themeRoot.getAttribute("data-tpl-theme");
  if (themeValue) panel.setAttribute("data-tpl-theme", themeValue);
  else panel.removeAttribute("data-tpl-theme");

  const computed = window.getComputedStyle(themeRoot);
  for (let i = 0; i < computed.length; i++) {
    const prop = computed[i];
    if (prop.startsWith("--tpl-")) {
      panel.style.setProperty(prop, computed.getPropertyValue(prop));
    }
  }
  panel.style.fontFamily = computed.fontFamily;
  panel.style.fontSize = computed.fontSize;
  panel.style.lineHeight = computed.lineHeight;
}
